import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import { ItemNotFound } from "@/components/molecules/NotFound"
import { UserProfileList } from "./list"
import { PaginationContainer } from "../PaginationContainer/pagination-container"
import { ProductControls } from "@/components/molecules/ProductControl/product-control"

export const ProfileListSection = ({ consultants, totalPages, currentPage, translations }: { consultants: any, totalPages: number, currentPage: number, translations: Record<string, any> }) => {
  if (!consultants.length) return <ItemNotFound />

  return (
    <section className="bg-gray-50 dark:bg-gray-800">
      <div className="mx-auto max-w-screen-2xl px-5 py-16 xl:px-0">
        <div className="mx-auto flex justify-between justify-items-center justify-self-center">
          <HeadingText level={2} className="mb-8 lg:text-center">
            {`${consultants.length} ${translations.consultants.available}`}
          </HeadingText>
        </div>
        <UserProfileList profiles={consultants} translations={translations} />
        <PaginationContainer queryParams={{ page: currentPage }} totalPages={totalPages} />
      </div>
    </section>
  )
}
